var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let loaded = false;
function init(_0) {
  return __async(this, arguments, function* ({
    id,
    trackScriptUrl,
    onClose
  }) {
    if (loaded) {
      console.warn("LiveAgent already initialised");
      return;
    }
    return new Promise((resolve, reject) => __async(this, null, function* () {
      try {
        (function(d, src, c) {
          const t = d.scripts[d.scripts.length - 1], s = d.createElement("script");
          s.id = id;
          s.async = true;
          s.src = src;
          s.onload = s.onreadystatechange = function() {
            const rs = this.readyState;
            if (rs && rs != "complete" && rs != "loaded") {
              return;
            }
            c(this);
          };
          t.parentElement.insertBefore(s, t.nextSibling);
        })(document, trackScriptUrl, function(e) {
          loaded = true;
          LiveAgent.disableOnlineVisitorsTracking();
          let popupInterval;
          let chatButton;
          resolve({
            addUserDetails(userDetails) {
              if (userDetails) {
                LiveAgent.addContactField("UserID", userDetails.userId);
                LiveAgent.setUserDetails(userDetails.email, userDetails.firstName, userDetails.lastName);
              } else {
                LiveAgent.clearAllUserDetails();
              }
            },
            createButton(chatId) {
              if (chatButton) {
                return;
              }
              chatButton = LiveAgent.createButton(chatId, e);
              overwriteOnClose(chatButton);
              return waitButtonInitialization();
            },
            openChat() {
              if (!chatButton || !chatButton.isInitialized()) {
                console.warn("LiveAgent button not initialized yet");
                return;
              }
              chatButton.onClick();
              if (getPopup()) {
                onPopupClose(() => {
                  LiveAgent.instance.setOpenedWidget(void 0);
                  chatButton.onCloseFunction_();
                });
              }
            }
          });
          function overwriteOnClose(chatButton2) {
            if (onClose) {
              chatButton2.oldOnCloseFunction_ = chatButton2.onCloseFunction_;
              chatButton2.onCloseFunction_ = function() {
                chatButton2.oldOnCloseFunction_();
                onClose();
              };
            }
          }
          function waitButtonInitialization() {
            return __async(this, null, function* () {
              const maxTimeout = 5e3;
              const intervalTimeout = 100;
              let currentTimeout = 0;
              return new Promise((resolve2, reject2) => {
                const interval = setInterval(() => {
                  currentTimeout += intervalTimeout;
                  if (chatButton.isInitialized()) {
                    clearInterval(interval);
                    resolve2();
                  } else if (currentTimeout >= maxTimeout) {
                    clearInterval(interval);
                    reject2(`Live agent button not initialized after ${maxTimeout / 1e3} seconds`);
                  }
                }, intervalTimeout);
              });
            });
          }
          function onPopupClose(callback) {
            clearInterval(popupInterval);
            popupInterval = setInterval(() => {
              if (getPopup().closed) {
                clearInterval(popupInterval);
                callback();
              }
            }, 1e3);
          }
          function getPopup() {
            var _a;
            return (_a = LiveAgent.instance.openedWidget) == null ? void 0 : _a.popupWindow;
          }
        });
      } catch (e) {
        reject(e);
      }
    }));
  });
}

export { init };
